import { IConfig } from "./IConfig";

const configLabs: IConfig = {
  trackingCodeUrl: "cdn.livechatinc.com/labs/tracking.js",
  dontTrackLicenseActivity: false,
  amplitudeKey: "ab752ccc02f63a399e5414c8bb07c9e",
  amplitudeQueue: "https://api.labs.text.com/product-event/v2/event/amplitude",
};

export default configLabs;
